import {
  MaintenanceTaskDto,
  MaintenanceCategory,
  MaintenancePriority,
  RecurrenceType,
  IntervalUnit,
  LeadTimeUnit,
  MAINTENANCE_CATEGORIES,
  MAINTENANCE_PRIORITIES,
  RECURRENCE_TYPES,
  INTERVAL_UNITS,
  LEAD_TIME_UNITS,
} from "../../services/api";

// Etiquetas en español para enums
export const CATEGORY_LABELS: Record<MaintenanceCategory, string> = {
  Other: "Otro",
  Lubrication: "Lubricación",
  Replacement: "Sustitución",
  Inspection: "Inspección",
  Calibration: "Calibración",
  Cleaning: "Limpieza",
  Legal: "Legal/ITV",
};

export const PRIORITY_LABELS: Record<MaintenancePriority, string> = {
  Low: "Baja",
  Normal: "Normal",
  High: "Alta",
  Critical: "Crítica",
};

export const RECURRENCE_LABELS: Record<RecurrenceType, string> = {
  OneTime: "Una sola vez",
  Interval: "Recurrente (intervalo)",
};

export const INTERVAL_UNIT_LABELS: Record<IntervalUnit, string> = {
  Days: "días",
  Weeks: "semanas",
  Months: "meses",
  Years: "años",
};

export const LEAD_TIME_UNIT_LABELS: Record<LeadTimeUnit, string> = {
  Minutes: "minutos",
  Hours: "horas",
  Days: "días",
  Weeks: "semanas",
};

// Mapeo entre nombre de enum y valor numérico (que es lo que serializa C#).
export const categoryToInt = (c: MaintenanceCategory) => MAINTENANCE_CATEGORIES.indexOf(c);
export const priorityToInt = (p: MaintenancePriority) => MAINTENANCE_PRIORITIES.indexOf(p);
export const recurrenceToInt = (r: RecurrenceType) => RECURRENCE_TYPES.indexOf(r);
export const intervalUnitToInt = (u: IntervalUnit) => INTERVAL_UNITS.indexOf(u);
export const leadTimeUnitToInt = (u: LeadTimeUnit) => LEAD_TIME_UNITS.indexOf(u);

export const intToCategory = (n: number) => MAINTENANCE_CATEGORIES[n] ?? "Other";
export const intToPriority = (n: number) => MAINTENANCE_PRIORITIES[n] ?? "Normal";
export const intToRecurrence = (n: number) => RECURRENCE_TYPES[n] ?? "Interval";
export const intToIntervalUnit = (n: number | null | undefined) =>
  n == null ? null : INTERVAL_UNITS[n] ?? null;
export const intToLeadTimeUnit = (n: number) => LEAD_TIME_UNITS[n] ?? "Days";

export function formatDate(iso: string | null | undefined, withTime = true): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return withTime
    ? d.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" });
}

export function todayDateInputValue(): string {
  return new Date().toISOString().slice(0, 10);
}

export function describeRecurrence(task: MaintenanceTaskDto): string {
  if (task.recurrenceType === recurrenceToInt("OneTime")) {
    return "Una vez";
  }
  if (task.intervalValue == null || task.intervalUnit == null) return "—";
  const unit = INTERVAL_UNITS[task.intervalUnit] ?? "Days";
  return `Cada ${task.intervalValue} ${INTERVAL_UNIT_LABELS[unit]}`;
}

export function describeReminders(task: MaintenanceTaskDto): string {
  if (!task.reminders || task.reminders.length === 0) return "Sin avisos";
  return task.reminders
    .map((r) => `${r.leadTimeValue} ${LEAD_TIME_UNIT_LABELS[LEAD_TIME_UNITS[r.leadTimeUnit] ?? "Days"]}`)
    .join(" · ");
}

export function isOverdue(task: MaintenanceTaskDto): boolean {
  if (!task.isActive) return false;
  return new Date(task.nextDueAt).getTime() <= Date.now();
}

export function daysUntil(iso: string): number {
  const ms = new Date(iso).getTime() - Date.now();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}
